export default __webpack_public_path__ + "static/media/gwn31.f6f68bb8.webp";